/*
 * Essa tela mostra as rotas retornadas em um critério de pesquisa e o progresso da sua execução no decorrer do dia
 * onde o status de cada entrega será exibido como uma barra horizontal que indicará o inicio, o fim e o status.
 * O resultado final será semelhante a um gráfico de gant.
 *
 * @author Mozart Diniz mozartdiniz@sagaranatech.com
 *
 */

import { DefaultRequest } from 'scripts/api';

class RouteProgressRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "RouteProgress";

    super(entityName);

    var paginateOptions = Monet.Grid.Utils.paginationOptions;
    if (!App.Forms.RouteProgress) {
      App.Forms.RouteProgress = {
        layout: {},
        table: null,
        dataProvider: null,
        pagination: {
          first: paginateOptions.FIRST,
          max: paginateOptions.MAX_RESULT,
          blocked: false,
          canIncrement: true
        }
      };
    }

    App.Objects.RouteProgress = this;
  }

  show = () => {
    const requests = new Greenmile.RouteProgress.Request();
    const contentHtml = document.getElementById("RouteProgress");
    if (
      contentHtml !== null &&
      contentHtml.getAttribute("rendered") !== "true"
    ) {
      contentHtml.setAttribute("rendered", "true");
      var dm = new Monet.Builder.DataMapper();
      dm.setEntity("RouteProgress");
      dm.build(
        (function(scope) {
          return function() {
            const request = new DefaultRequest({
              url: "form/RouteProgress/index",
              dataType: "json",
              success: (function(scope) {
                return function(data) {
                  App.Forms.RouteProgress.layout =
                    App.Forms.RouteProgress.layout || {};
                  App.Forms.RouteProgress.layout.index = data;

                  scope.createBaseStructure();
                  scope.collectAllNeededInfo();
                  App.Views.RouteProgress.createFilters();
                  scope.list();
                  Monet.I18n.translateInterface();
                };
              })(scope)
            });
            request.send();
          };
        })(this, requests, dm)
      );
    }
  };

  createBaseStructure = () => {
    const contentHtml = document.getElementById("RouteProgress");
    const gridBase = document.createElement("div");

    const gridActionsDiv = document.createElement("div");
    gridActionsDiv.className = "gridActions ui-widget-header";

    gridBase.className = "RouteProgressGridContainer";
    gridBase.id = "form_and_grid";
    gridBase.style.width = "100%";
    gridBase.style.height = "500px";

    contentHtml.appendChild(gridActionsDiv);
    contentHtml.appendChild(gridBase);
  };

  requestDataToUpdate = () => {
    var collectionProgress = new App.Collections.RouteViews();
    var filter = App.Forms.RouteProgress.filterBuilder;
    var updater = App.Forms.RouteProgress.controlUpdater;
    var page = updater.getPageByScrollPosition();
    var pages = updater.getPages();
    var firstResult = 0;
    var projectionString = filter.getProjection();
    var criteria = filter.getCriteriaChain();
    var projection = JSON.parse(projectionString);
    var loading = new Monet.UI.LoadingData();

    loading.init();
    loading.show();

    var callback = function(data) {
      loading.hide();
      Greenmile.RouteProgress.data = data;
      App.Views.RouteProgress.createGrid(updater.updateDataToGrid);
    };

    if (page !== 0) {
      firstResult = pages[page].firstResult;
    }

    projection.firstResult = firstResult;

    projectionString = JSON.stringify(projection);

    collectionProgress.filterWithRestrictions({
      restrictionUrl: "/Progress",
      filter: criteria,
      criteria: projectionString,
      success: callback
    });
  };

  updateGrid = () => {
    var filter = App.Forms.RouteProgress.filterBuilder;
    filter.executeFilter();
  };

  list = () => {
    var customizeColumns = document.querySelector(
      "#RouteProgress .MonetUIGridActionsColumns"
    );

    if (customizeColumns) {
      customizeColumns.style.display = "none";
    }

    App.Forms.RouteProgress.pagination.first = 0;

    this.updateGrid();
  };

  collectAllNeededInfo = () => {
    var grid = new Greenmile.RouteProgress.Grid();
    var view = App.Views.RouteProgress;

    grid.setEntity("RouteProgress");
    grid.showGrid("RouteProgress");

    view.createLabels();

    Greenmile.RouteProgress.Updater.runScheduler();
  };
}

App.Routers.RouteProgress = RouteProgressRouter;
